<template>
  <div>
    <div class="_rfp_mctb_popup_01_ rfp-mctb-common-buynow-header">
      <button
        class="_rfp_mctb_popup_02_ rfp-mctb-common-buynow rfp-mctb-product-list-card-buttom"
        @click="popUpEnable(storeLocatorModeOptions.Product.BuyOnlineTags, buyNowText)"
      >
        {{ buyNowText }}
      </button>
    </div>
    <div v-if="viewType === 'Carousel'">
      <div
        v-if="showPopUp"
        ref="popup"
        role="dialog"
        aria-modal="true"
        tabindex="-1"
        class="_rfp_mctb_popup_03_ rfp-mctb-modal-mask-slider modal-vue"
      >
        <div class="_rfp_mctb_popup_04_ rfp-mctb-modal-wrapper-slider modal-vue--content">
          <div class="_rfp_mctb_popup_05_ rfp-mctb-modal-container modal-vue--content-panel">
            <div class="_rfp_mctb_popup_06_ rfp-mctb-carousel-mode-header vue-tabs">
              <button
                class="_rfp_mctb_popup_07_ rfp-mctb-modal-close"
                :aria-label="a11y.closeButtonAriaLabel"
                :class="{ 'rfp-mctb-modal-close-rtl': enableRtl }"
                @click="closeModal"
              >
                X
              </button>
              <h1 class="_rfp_mctb_popup_08_ rfp-mctb-carousel-mode-header-top-header">
                {{ carouselHeaderText }}
              </h1>

              <div v-if="showTabs" class="_rfp_mctb_list_006_ nav-tabs-navigation">
                <div class="_rfp_mctb_list_007_ nav-tabs-wrapper">
                  <ul role="tablist" class="_rfp_mctb_list_008_ nav nav-tabs">
                    <li
                      v-for="(country, index) in countriesWithRetailers"
                      :id="country.DisplayName"
                      :key="country.DisplayName"
                      role="tab"
                      tabindex="0"
                      :aria-selected="String(index === activeTabIndex)"
                      aria-controls="rfp-mctb-retailer-tabpanel"
                      class="_rfp_mctb_list_009_ tab active"
                      :class="{ active__tab: index === activeTabIndex }"
                      @keydown.space.prevent="setActiveTab(index)"
                      @keydown.enter="setActiveTab(index)"
                      @click="setActiveTab(index)"
                    >
                      <span class="_rfp_mctb_list_0010_ active_tab tabs__link">
                        <span class="_rfp_mctb_list_0011_ title title_center">
                          {{ country.DisplayName }}
                        </span>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div id="rfp-mctb-retailer-tabpanel" :role="showTabs ? 'tabpanel' : null">
                <rfp-mctb-carousel
                  :key="activeTabCountry?.Name"
                  :enable-rtl="enableRtl"
                  :autoplay="false"
                  :autoplay-timeout="10000"
                  :loop="false"
                  :autoplay-hover-pause="true"
                  :min-swipe-distance="8"
                  pagination-active-color="#f30606"
                  pagination-color="#efefef"
                  :pagination-padding="10"
                  :pagination-size="10"
                  :per-page="1"
                  :navigation-enabled="true"
                  :pagination-enabled="false"
                  :productname="productname"
                  :productids="productids"
                  :slide-count="computedRetailers.length"
                  :a11y="{
                    previousAriaLabel: a11y.previousAriaLabel,
                    nextAriaLabel: a11y.nextAriaLabel,
                  }"
                  @currentPageChange="(activePage) => (currentPage = activePage)"
                >
                  <rfp-mctb-slide
                    v-for="(retailer, index) in computedRetailers"
                    :key="retailer.Name"
                    :enable-rtl="enableRtl"
                    :inert="index !== currentPage"
                  >
                    <div class="_rfp_mctb_popup_09_ rfp-mctb-slider-outer">
                      <div
                        class="_rfp_mctb_popup_10_ rfp-mctb-slider-description rfp-mctb-image-alignment"
                      >
                        <img
                          class="_rfp_mctb_popup_11_ rfp-mctb-button-image"
                          :src="retailer.Logo"
                          alt=""
                        />
                      </div>
                      <p
                        class="_rfp_mctb_popup_12_ rfp-mctb-slider-description"
                        v-html="retailer.Description"
                      ></p>
                      <button
                        class="_rfp_mctb_popup_13_ rfp-mctb-common-buynow"
                        @click="
                          pageRedirectUrl(
                            retailer.RetailerUrl,
                            retailer.OpenInNewWindow,
                            retailer.RetailerTags,
                            retailer.RetailerTagsGS,
                            retailer.Name,
                          )
                        "
                      >
                        <span class="_rfp_mctb_popup_14_ rfp-mctb-button-text">
                          {{ retailer.Name }}
                        </span>
                      </button>
                    </div>
                  </rfp-mctb-slide>
                  <rfp-mctb-slide v-if="computedRetailers.length === 0">
                    <div class="retailer-unavailable_04">
                      {{ retailerUnavailable }}
                    </div>
                  </rfp-mctb-slide>
                </rfp-mctb-carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="viewType === 'Default - PopupMode Only'">
      <div
        v-if="showPopUp"
        ref="popup"
        role="dialog"
        aria-modal="true"
        tabindex="-1"
        class="_rfp_mctb_popup_03_ rfp-mctb-modal-mask"
      >
        <div class="_rfp_mctb_popup_04_ rfp-mctb-modal-wrapper">
          <div class="_rfp_mctb_popup_05_ rfp-mctb-modal-container">
            <div class="_rfp_mctb_popup_06_ rfp-mctb-carousel-mode-header">
              <button
                class="_rfp_mctb_popup_07_ rfp-mctb-modal-close"
                :class="{ 'rfp-mctb-modal-close-rtl': enableRtl }"
                :aria-label="a11y.closeButtonAriaLabel"
                @click="closeModal"
              >
                X
              </button>
              <rfp-mctb-list-mode
                :retailer-unavailable="retailerUnavailable"
                :component-diffs="componentDiffs"
                :carousel-header-text="carouselHeaderText"
                :store-locator-mode-options="storeLocatorModeOptions"
                :productname="productname"
                :productids="productids"
                :initial-extra-params="extraParams"
              ></rfp-mctb-list-mode>
            </div>
          </div>
        </div>
      </div>
    </div>
    <rfp-mctb-pop-up-action-mode
      v-else-if="showActionMode && showPopUp"
      ref="popupComponent"
      :productname="productname"
      :productids="productids"
      :retailer-unavailable="retailerUnavailable"
      :header-text="carouselHeaderText"
      :component-diffs="componentDiffs"
      :initial-data="storeLocatorModeOptions"
      :initial-extra-params="extraParams"
      :popup-direction="popupAlignment"
      :close-button-aria-label="a11y.closeButtonAriaLabel"
    ></rfp-mctb-pop-up-action-mode>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import RfpMctbPopUpActionMode from '../rfp-mctb-pop-up-action-mode/rfp-mctb-pop-up-action-mode.vue';
import RfpMctbListMode from '../rfp-mctb-list-mode/rfp-mctb-list-mode.vue';
import RfpMctbCarousel from '../rfp-mctb-slider/rfp-mctb-carousel.vue';
import RfpMctbSlide from '../rfp-mctb-slider/rfp-mctb-slide.vue';
import ServiceType from '../rfp-mctb-tags/tagging-service-type';
import { trapFocus } from '../../../../shared/utils/dom/focus';

export default {
  name: 'rfp-mctb-pop-up-mode',
  components: {
    RfpMctbPopUpActionMode,
    RfpMctbListMode,
    RfpMctbCarousel,
    RfpMctbSlide,
  },
  props: {
    storeLocatorModeOptions: {
      type: Object,
      required: true,
    },
    buyNowText: {
      type: String,
      required: true,
    },
    carouselHeaderText: {
      type: String,
      default: 'Choose a Retailer',
    },
    viewType: {
      type: String,
      required: true,
    },
    enableRtl: {
      type: Boolean,
      required: true,
    },
    componentDiffs: {
      type: Boolean,
      required: true,
    },
    retailerUnavailable: {
      type: String,
      required: true,
    },
    productname: {
      type: String,
      required: true,
    },
    productids: {
      type: String,
      required: true,
    },
    a11y: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showPopUp: false,
      eventProjectDataLayer: {},
      activeTabIndex: 0,
      areaValue: true,
      tabRetailerList: [],
      extraParams: {},
      popupDirection: false,
      findDatalayer: true,
      deactivateFocusTrap: null,
      currentPage: 0,
    };
  },
  computed: {
    popupAlignment() {
      try {
        return this.viewType.split(' - ')[0].toLowerCase();
      } catch {
        return 'top';
      }
    },
    showActionMode() {
      // TODO: in theory we shouldn't need this garbage, instead it would be the final ELSE in the
      // rendering
      return (
        [
          'Bottom - PopupMode Only',
          'Left - PopupMode Only',
          'Right - PopupMode Only',
          'Top - PopupMode Only',
        ].indexOf(this.viewType) >= 0
      );
    },
    countriesWithRetailers() {
      return this.storeLocatorModeOptions.CountryList.filter((item) => {
        return item.Name in this.retailersByCountryName;
      });
    },
    activeTabCountry() {
      return this.countriesWithRetailers[this.activeTabIndex];
    },
    retailersByCountryName() {
      return this.storeLocatorModeOptions.Product.Retailers.reduce((acc, item) => {
        acc[item.Country] ||= [];
        acc[item.Country].push(item);
        return acc;
      }, {});
    },
    activeCountryTabRetailers() {
      return this.retailersByCountryName[this.activeTabCountry?.Name] || [];
    },
    computedRetailers() {
      if (this.countriesWithRetailers.length > 0) {
        return this.activeCountryTabRetailers;
      }
      return this.storeLocatorModeOptions.Product.Retailers || [];
    },
    showTabs() {
      return this.storeLocatorModeOptions.CountryList.length > 1;
    },
  },
  watch: {
    async showPopUp(newVal) {
      if (newVal) {
        await this.$nextTick();
        const popup = this.$refs.popupComponent?.$refs.popup || this.$refs.popup;
        if (!popup) return;
        this.deactivateFocusTrap = trapFocus(popup);
      } else if (this.deactivateFocusTrap) {
        this.deactivateFocusTrap();
        this.deactivateFocusTrap = null;
      }
    },
    activeTabIndex() {
      this.currentPage = 0;
    },
  },
  created() {
    eventBus.on('rfp-auto-popup-open-buynow-true', () => {
      this.popupDirection = true;
      this.popUpEnable(this.storeLocatorModeOptions.Product.BuyOnlineTags, this.buyNowText);
    });
    /* istanbul ignore next */
    eventBus.on('rfp-optional-popup-close', () => {
      this.closeModal();
    });
    /* istanbul ignore next */
    eventBus.on('rfp-mctb-datalayer-event', (val) => {
      this.eventProjectDataLayer = val;
    });
    /* istanbul ignore next */
    eventBus.on('rfp-mctb-extra-param-component', (val) => {
      this.extraParams = val;
    });
    eventBus.emit('rfp-mctb-extra-param-component1');
    eventBus.on('rfp-mctb-enable-popup-direction', () => {
      this.findDatalayer = false;
      this.popupDirection = true;
      this.popUpEnable(this.storeLocatorModeOptions.Product.BuyOnlineTags, this.buyNowText);
    });
  },
  mounted() {
    document.addEventListener('keydown', this.handleCloseOnEsc);
  },
  unmounted() {
    this.handleUnmounted();
  },
  destroyed() {
    this.handleUnmounted();
  },
  methods: {
    handleUnmounted() {
      document.removeEventListener('keydown', this.handleCloseOnEsc);
    },
    handleCloseOnEsc(event) {
      if (this.showPopUp && event.key === 'Escape') {
        this.closeModal();
      }
    },
    popUpEnable(newTags, retailerName) {
      eventBus.emit('rfp-mctb-scan-to-buy-redirect', this.popupDirection);
      if (this.popupDirection) {
        if (window.dataLayer !== undefined && newTags !== '' && this.findDatalayer) {
          let tags = {};
          try {
            tags = JSON.parse(newTags);
          } catch (e) {
            console.log('Cannot parse tags', e);
          }

          eventBus.emit('rfpTaggingFoundation', {
            data: tags,
            values: {
              productName: this.productname,
              productId: this.productids,
              retailerName: retailerName,
            },
            extraParams: this.extraParams,
            service: ServiceType.GA,
          });
        }
        this.showPopUp = true;
        this.findDatalayer = true;
        eventBus.emit('rfp-mctb-optional-popup-enable');
        window.eventBus?.$emit('rfp-mctb-optional-popup-enable');
      }
    },
    closeModal() {
      this.showPopUp = false;
      window.eventBus?.$emit('rfp-mctb-popup-close');
    },
    pageRedirectUrl(redirectURL, OpenInNewWindow, standardTagsString, gsTagsString, retailerName) {
      const service = window.dataLayer ? ServiceType.GA : ServiceType.GSQ;

      try {
        const tags = JSON.parse(window.dataLayer ? standardTagsString : gsTagsString);
        tags &&
          eventBus.emit('rfpTaggingFoundation', {
            data: tags,
            values: {
              productName: this.productname,
              productId: this.productids,
              retailerName: retailerName,
            },
            extraParams: this.extraParams,
            service,
          });
      } catch (e) {
        console.error(
          `error/rfp-mctb-pop-up-mode#pageRedirectUrl: ${service} tag parsing failed`,
          e,
        );
      }

      const target = OpenInNewWindow === true ? '_blank' : '_self';
      window.open(redirectURL, target);
    },
    setActiveTab(index) {
      this.activeTabIndex = index;
    },
  },
};
</script>
